import { QueryClient } from '@tanstack/react-query';
import { noop } from 'lodash';

import { isTestEnv } from '@app/constants';

const cacheTimeMinutes = 5;

export const createReactQueryClient = (): QueryClient =>
  new QueryClient({
    logger: {
      // eslint-disable-next-line no-console
      log: console.log,
      warn: console.warn,
      // turn off react-query errors in console for testing scenarios with failed requests
      error: isTestEnv ? noop : console.error,
    },
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        cacheTime: 1000 * 60 * cacheTimeMinutes,
      },
    },
  });
